import { SxProps, Theme } from '@mui/material';

interface Styles {
  container: SxProps<Theme>;
  tabsContainer: SxProps<Theme>;
  tabButton: SxProps<Theme>;
  tableContainer: SxProps<Theme>;
  tableHeader: SxProps<Theme>;
  comingSoon: SxProps<Theme>;
}

export const styles: Styles = {
  container: {
    py: 3,
    px: 4,
    maxWidth: '1400px',
    margin: '0 auto',
  },
  tabsContainer: {
    mb: 3,
    backgroundColor: 'transparent',
  },
  tabButton: {
    color: 'rgba(255, 255, 255, 0.6)',
    borderRadius: 0,
    paddingBottom: '12px',
    paddingTop: '12px',
    marginRight: '24px',
    textTransform: 'none',
    fontSize: '16px',
    '&:hover': {
      backgroundColor: 'transparent',
      color: 'white',
    },
  },
  tableContainer: {
    p: 3,
    backgroundColor: (theme) => theme.palette.background.paper,
    borderRadius: '8px',
    boxShadow: (theme) => theme.shadows[3],
    overflow: 'hidden',
  },
  tableHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 2,
    pb: 2,
    borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
  },
  comingSoon: {
    p: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 300,
    backgroundColor: (theme) => theme.palette.background.paper,
    borderRadius: 1,
  },
};